.authenticationModal {
  z-index: 1500;

  > .content {
    @media (min-width: 769px) {
      max-width: 26.75rem;
      margin: max(7%, 7.1875rem) auto;
    }
  }
}
